import {
  ASYNC_TASK_FAILED_STATUS,
  ASYNC_TASK_KEY,
  ASYNC_TASK_SUCCESS_STATUS,
} from '../constants/async'

export function getAsyncTaskId(data) {
  return data[ASYNC_TASK_KEY]
}

export function isAsyncTaskFailedStatus(task) {
  return task?.status.toLowerCase() === ASYNC_TASK_FAILED_STATUS
}

export function isAsyncTaskSuccessStatus(task) {
  return task?.status.toLowerCase() === ASYNC_TASK_SUCCESS_STATUS
}

export function isAsyncTaskFinished(task) {
  return isAsyncTaskFailedStatus(task) || isAsyncTaskSuccessStatus(task)
}

export function sleep(ms) {
  return new Promise(r => setTimeout(r, ms))
}

export function createDeferredPromise() {
  let resolve

  const promise = new Promise(r => {
    resolve = r
  })

  return { promise, resolve }
}
